export const SampleHeader = () => (
  <div className="h-16 bg-surface-50 p-2">
    <div className="h-full border-4 border-dashed border-surface-200/50 rounded-lg flex justify-center items-center">
      <p className="text-black">Navbar</p>
    </div>
  </div>
)
